package one.healthium.settings.ui.meal_plan

import one.healthium.loco.LString

internal data class MealPlanUiModel(
    val id: String,
    val name: LString,
    val checked: Boolean,
)
